import { useEffect } from "react";
import { Card } from "antd";
import { useTranslation } from "react-i18next";
import { DataGridProvider } from "../../core/components/data-grid/DataGridContext";
import LayoutWithSider from "../../core/components/layout/layout-with-sider/LayoutWithSider";
import ReportBillingFilter from "../../app/report-billing/billing-grid/ReportBillingFilter";
import ReportBillingGrid from "../../app/report-billing/billing-grid/ReportBillingGrid";
import ReportBillingQuickFilterBar from "../../app/report-billing/billing-grid/ReportBillingQuickFilterBar";
import AppConfig from "../../core/service/AppConfig";

export default function ReportBillingPage() {
    const { t } = useTranslation();

    useEffect(() => {
        document.title = `${t('Report Billing')} | ${AppConfig.getRisTitle()}`
    }, []);

    return (
        <DataGridProvider>
            <LayoutWithSider
                fullWidth={true}
                sidebarTitle={t('Billing Filter')}
                rememberOpen={false}
                sidebarComponent={<ReportBillingFilter />}
            >
                {/* Hızlı filtreler grid kartının üstünde, her blok ayrı kart; uygulanan filtreyi sol panelle paylaşır. */}
                <ReportBillingQuickFilterBar />
                <Card title={t('Report Billing')}>
                    <ReportBillingGrid />
                </Card>
            </LayoutWithSider>
        </DataGridProvider>
    )
}
